import { Check } from "lucide-react";

interface Props {
  location: string;
}

/** Skimmable summary box shown near the top of every location article.
 *  Same 5 points on every page — deliberate: they're conversion primitives
 *  (price, cover, credentials), not editorial. */
export function LocationTakeaways({ location }: Props) {
  const points = [
    "Fixed-fee monthly HR retainer from £200, no per-call surcharges",
    `CIPD-qualified advisers on call for ${location} employers`,
    "Tribunal indemnity cover included on every retainer",
    "Bespoke contracts, handbooks and ER support written for your business",
    "24/7 helpline plus on-site visits across the surrounding area",
  ];
  return (
    <aside
      aria-label="Key takeaways"
      className="mx-auto mt-10 max-w-3xl rounded-2xl border-l-4 border-accent bg-muted/60 p-6 sm:p-8"
    >
      <p className="text-xs font-semibold uppercase tracking-widest text-accent">
        Key takeaways
      </p>
      <ul className="mt-4 space-y-3">
        {points.map((p) => (
          <li key={p} className="flex items-start gap-3 text-sm text-foreground">
            <Check className="mt-0.5 size-4 shrink-0 text-accent" aria-hidden="true" />
            <span>{p}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
